import { FooterResponseProps } from '@/blocks/Footer/types';
import { HeaderStrapiProps } from '@/features/Header/transformer';

import bentoFooterMock from '@/__visual-tests__/mocks/bento-footer.mock';
import { footerMock } from '@/__visual-tests__/mocks/footer.mock';
import { headerMock } from '@/__visual-tests__/mocks/header.mock';

import { Entry, GetPageResult, PageResponse } from '../types';

// eslint-disable-next-line no-restricted-syntax
export const IS_VISUAL_TEST = process.env.VISUAL_TESTS === 'true';

const image = {
  image: {
    data: {
      attributes: {
        name: 'visual-test-placeholder.svg',
        alternativeText: 'Placeholder',
        width: 600,
        height: 400,
        url: '/images/visual-test-placeholder.svg',
        formats: {},
      },
    },
  },
};

const metadata = {
  title: 'Visual Test Article',
  releaseDate: '2024-01-01',
  timeSpentReading: 5,
  description: {
    text: [
      {
        type: 'paragraph',
        children: [
          {
            type: 'text',
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          },
        ],
      },
    ],
  },
  image,
  author: {
    data: {
      attributes: { name: 'Jane Smith', authorPageSlug: 'jane-smith', image },
    },
  },
  topics: {
    data: [
      { attributes: { topic: 'Data Collection', slug: 'data-collection' } },
    ],
  },
};

const entryAttributes = { slug: 'visual-test-article', metadata };

const VISUAL_TEST_LATEST_BLOGPOST = {
  data: [{ id: '1', attributes: entryAttributes }],
  meta: { pagination: { page: 1, pageCount: 1, pageSize: 1, total: 1 } },
} as unknown as PageResponse<Entry>;

const visualTestBlogBySlug = (slug: string) =>
  ({
    data: { id: '1', attributes: { ...entryAttributes, slug } },
    meta: null,
  } as unknown as GetPageResult<Entry>);

const mockResult = <T>(attributes: unknown) =>
  Promise.resolve({
    data: { id: '1', attributes },
    meta: null,
  } as unknown as GetPageResult<T>);

type VisualTestFixtureMap = {
  '/blogs': (slug: string) => Promise<GetPageResult<Entry>>;
  '/blogs/latest': () => Promise<PageResponse<Entry>>;
  '/headers': () => Promise<GetPageResult<HeaderStrapiProps>>;
  '/footers': () => Promise<GetPageResult<FooterResponseProps>>;
};

export const visualTestFixtures: VisualTestFixtureMap = {
  '/blogs': (slug: string) => Promise.resolve(visualTestBlogBySlug(slug)),
  '/blogs/latest': () => Promise.resolve(VISUAL_TEST_LATEST_BLOGPOST),
  '/headers': () => mockResult<HeaderStrapiProps>(headerMock),
  '/footers': () =>
    mockResult<FooterResponseProps>({
      ...footerMock,
      bentoFooter: bentoFooterMock.block,
    }),
};
